import React, { useState, useEffect } from 'react';

// Internal state for the singleton
let update: ((show: boolean, message?: string, allowUserClose?: boolean) => void) | null = null;

// Exported global toggle functions
export function showDimmer(message: string, allowUserClose: boolean = false) {
  if (update) update(true, message, allowUserClose);
}
export function hideDimmer() {
  if (update) update(false);
}

export const Dimmer: React.FC = () => {

    const [showDimmer, setShowDimmer] = useState(false);
    const [message, setMessage] = useState<string | undefined>(undefined);
    const [allowUserClose, setAllowUserClose] = useState<boolean>(false);

    // Register the updater on mount, unregister on unmount
    useEffect(() => {
        update = (show, msg, userClose) => {
            setShowDimmer(show);
            setMessage(msg);
            setAllowUserClose(userClose || false);
        };
        return () => {
            update = null;
        };
    }, []);
    
    if (!showDimmer) {
        return null;
    } else {
        return (
            <div style={{
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
                opacity: 1,
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(5px)', // <--- this blurs the background!
                WebkitBackdropFilter: 'blur(50px)', // for Safari support
            }}>
                <div style={{
                    position: 'relative',
                    color: "white",
                    background: "rgba(0, 0, 0, 0.8)",
                    padding: "20px 30px",
                    borderRadius: "15px",
                    boxShadow: "0 0 40px 40px rgba(0,0,0,0.8)",
                    minWidth: '200px',
                    textAlign: 'center'
                }}>
                    {allowUserClose && (
                        <button
                            onClick={() => hideDimmer()}
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                background: 'transparent',
                                border: 'none',
                                color: 'white',
                                fontSize: '24px',
                                cursor: 'pointer',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                            title="Close"
                        >
                            ×
                        </button>
                    )}
                    <h2 style={{
                        margin: '0',
                        fontSize: '18px',
                        fontWeight: 'normal'
                    }}>
                        {message}
                    </h2>
                </div>
            </div>
        )
    }
}